const userRoutes = [
	{
		path: "/user/footprint",
		name: "userFootprint",
		redirect: "/user/footprint/collect",
		component: () => import(/* webpackChunkName: "userFootprint" */ "@/views/user/footprint/index.vue"),
		children: [
			{
				path: "/user/footprint/collect",
				name: "userProductCollect",
				component: () => import(/* webpackChunkName: "userProductCollect" */ "@/views/product/collect/index.vue"),
			},
			{
				path: "/user/collect/resource",
				name: "userResourceCollect",
				component: () => import(/* webpackChunkName: "userProductCollect" */ "@/views/resource/collect/index.vue"),
			},
			{
				path: "/user/footprint/:type",
				name: "userFootprintType",
				component: () => import(/* webpackChunkName: "userFootprintType" */ "@/views/user/footprint/footprint.vue"),
			},
		],
	},
	{
		path: "/user/setting",
		name: "userSetting",
		component: () => import(/* webpackChunkName: "userSetting" */ "@/views/user/setting/setting.vue"),
	},
	{
		path: "/user/skill",
		name: "userSkill",
		component: () => import(/* webpackChunkName: "userSkill" */ "@/views/user/skill/index.vue"),
	},
	{
		path: "/user/auth-control",
		name: "userAuthControl",
		component: () => import(/* webpackChunkName: "userSkill" */ "@/views/authorization/auth-control.vue"),
	},
];

export default userRoutes;
